import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import PopularServices from '../components/PopularServices';
import Features from '../components/Features';
import WhyChooseUs from '../components/WhyChooseUs';
import AboutSection from '../components/AboutSection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <PopularServices />
      <Features />
      <AboutSection />
      <WhyChooseUs />
      <section style={{ padding: '80px 0', background: 'var(--off-white)' }} id="contact">
        <div className="container">
          <ContactForm />
        </div>
      </section>
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/919552319748?text=Hi,%20I%20need%20help%20with%20your%20services"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          backgroundColor: '#25D366',
          color: 'white',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '30px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
          zIndex: 1000,
          transition: 'all 0.3s ease',
          textDecoration: 'none'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </>
  );
};

export default Home;


